import { styled } from '@pata-app/themes';

export const HeroSectionContainer = styled.section`
  position: relative;

  display: flex;
  justify-content: center;
  flex-direction: column-reverse;

  background: ${({ theme }) => theme.core.colors.primary.blue.medium};

  img {
    display: none;

    height: 300px;
    object-fit: cover;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    flex-direction: row;

    img {
      position: absolute;
      top: 0;

      display: block;

      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const HeroContentContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  padding: ${({ theme }) => theme.core.sizing[2]}px;

  height: 500px;

  z-index: 2;

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    height: 400px;
  }
`;

export const HeroHeading = styled.h1`
  display: flex;
  flex-direction: column;

  margin: 0;

  margin-left: -2px;

  font-size: 40px;

  color: ${({ theme }) => theme.core.colors.greyscale.white};

  span {
    line-height: 1.2em;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    font-size: 45px;
  }
`;

export const HeroSubHeading = styled.p`
  color: ${({ theme }) => theme.core.colors.greyscale.white};

  margin: 0;

  font-size: ${({ theme }) => theme.core.fontSizes.l}px;

  max-width: 500px;
`;
